<template>
  <div class="project-file" v-if="fileData">
    <div class="file-item">
      <div class="title">招标相关文档</div>
      <file-download @getFileList="getFileList" :data="fileData.zbAttas"></file-download>
      <el-upload v-if="isLeader" class="upload-demo" :before-upload="handleBeforeUpload" :action="uploadUrl" multiple
         :on-success="handleAvatarSuccess_0">
        <el-button size="small" type="primary" :loading="isUpload">点击上传合同招标相关文档</el-button>
      </el-upload>
    </div>
    <div class="file-item">
      <div class="title">合同相关文档</div>
      <file-download @getFileList="getFileList" :data="fileData.htAttas"></file-download>
      <el-upload v-if="isLeader" class="upload-demo" :before-upload="handleBeforeUpload" :action="uploadUrl" multiple
         :on-success="handleAvatarSuccess_1">
        <el-button size="small" type="primary" :loading="isUpload">点击上传合同相关文档</el-button>
      </el-upload>
    </div>
    <div class="file-item">
      <div class="title">付款相关文档</div>
      <file-download @getFileList="getFileList" :data="fileData.payAttas"></file-download>
      <el-upload v-if="isLeader" class="upload-demo" :before-upload="handleBeforeUpload" :action="uploadUrl" multiple
         :on-success="handleAvatarSuccess_2">
        <el-button size="small" type="primary" :loading="isUpload">点击上传付款相关文档</el-button>
      </el-upload>
    </div>
  </div>
</template>
<script>
  import fileDownload from '../project/fileDownload'
  export default {
    props: ['contractId', 'isLeader'],
    components: {
      fileDownload,
    },
    data() {
      return {
        isUpload: false,
        uploadUrl: axios.defaults.baseURL + '/common/upload',
        fileData: "",
        type: 0,
      }
    },
    mounted() {
      this.getFileList()
    },
    methods: {
      isOfficeFile(type) {
        switch (type) {
          case 'doc':
          case 'docx':
          case 'xls':
          case 'xlsx':
          case 'ppt':
          case 'pptx':
            return true
            break;
          default:
            return false
            break;
        }
      },
      handleBeforeUpload() {
        this.isUpload = true
      },
      // 上传附件到对应列表
      relateUpload(type, res) {
        ajax.post("/contract/relate/files/upload", {
          contractId: this.contractId,
          type: type,
          attachments: res.vo.id
        }, (res) => {
          // 上传成功， 重新获取附件列表
          this.getFileList()
          this.isUpload = false
        })
      },
      // 点击上传附件
      handleAvatarSuccess_0(res, file) {
        this.relateUpload(0, res)
      },
      // 点击上传附件
      handleAvatarSuccess_1(res, file) {
        this.relateUpload(1, res)
      },
      // 点击上传附件
      handleAvatarSuccess_2(res, file) {
        this.relateUpload(2, res)
      },
      getFileList() {
        ajax.get('/contract/relate/files/' + this.contractId, '', (res) => {
          this.fileData = res.vo
        })
      }
    },
  }
</script>


// WEBPACK FOOTER //
// src/page/contract/file.vue